import styles from './stepped-form.module.scss';
import { PropsWithChildren, ReactNode } from 'react';

const SteppedForm = (props: PropsWithChildren<ReactNode>) => {
    return <form className={styles.form}>{props.children}</form>;
};

export default SteppedForm;
